document.addEventListener(
'DOMContentLoaded',
function(){

let current='subscription';

const hiddenInput =
document.getElementById(
'arcane-selling-plan'
);

function update(type){

current=type;

document
.querySelectorAll(
'[data-purchase-type]'
)
.forEach(el=>{

el.classList.toggle(
'active',
el.dataset.purchaseType===type
);

});

if(type==='subscription'){

hiddenInput.value =
window.arcaneSellingPlanId;

}else{

hiddenInput.value='';

}

}

document
.querySelectorAll(
'[data-purchase-type]'
)
.forEach(el=>{

el.addEventListener(
'click',
()=>{

update(
el.dataset.purchaseType
);

});

});

update('subscription');

});